/**
 * Wave 22B — cart recently-removed archive (Flutter ADR-073 parity).
 * Device-only localStorage; 30-day TTL; cap ~20. No cloud.
 *
 * Hooks Prestige /cart/change.js (quantity → 0) so /cart page reloads still archive.
 */
(function () {
  if (window.__erosCartRecentlyRemovedInit) return;
  window.__erosCartRecentlyRemovedInit = true;

  var STORAGE_KEY = 'eros:cart:recently-removed';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var MAX_ENTRIES = 20;
  var QTY_CAP = 6;
  var PANEL_ID = 'eros-cart-rr-panel';

  var cartByKey = Object.create(null);
  var i18n = {
    title: 'Recently removed',
    subtitle: 'Auto-deleted after 30 days',
    empty: 'No recently removed items',
    openTooltip: 'Recently removed items',
    addToCart: 'Add to cart',
  };
  var panelEl = null;
  var restoring = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function mergeI18nFromDom() {
    var node = document.querySelector('[data-eros-cart-rr-i18n]');
    if (!node) return;
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      Object.keys(parsed).forEach(function (key) {
        if (typeof parsed[key] === 'string' && parsed[key].trim()) {
          i18n[key] = parsed[key].trim();
        }
      });
    } catch (e) {
      /* keep defaults */
    }
  }

  function nowIso() {
    return new Date().toISOString();
  }

  function isExpired(entry) {
    if (!entry || !entry.deletedAt) return true;
    var t = Date.parse(entry.deletedAt);
    if (!Number.isFinite(t)) return true;
    return Date.now() - t > TTL_MS;
  }

  function readRaw() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeRaw(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* quota / private mode — fail soft */
    }
  }

  function listActive() {
    var kept = readRaw()
      .filter(function (entry) {
        return entry && entry.variantId != null && !isExpired(entry);
      })
      .sort(function (a, b) {
        return Date.parse(b.deletedAt) - Date.parse(a.deletedAt);
      });
    if (kept.length > MAX_ENTRIES) kept = kept.slice(0, MAX_ENTRIES);
    writeRaw(kept);
    return kept;
  }

  function archiveFromCartItem(item) {
    if (!item || item.variant_id == null) return;
    var variantId = String(item.variant_id);
    var qty = parseInt(item.quantity, 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    var entry = {
      variantId: variantId,
      quantity: qty,
      deletedAt: nowIso(),
      title: item.product_title || item.title || '',
      variantTitle: item.variant_title || '',
      image: item.image || '',
      price: item.final_price != null ? item.final_price : item.price,
      compareAt:
        item.original_price != null && item.original_price > (item.final_price != null ? item.final_price : item.price)
          ? item.original_price
          : item.compare_at_price || null,
      handle: item.handle || '',
      url: item.url || '',
      currencyCode: item.presentment_currency || '',
      quantityCap: QTY_CAP,
    };

    var next = listActive().filter(function (row) {
      return String(row.variantId) !== variantId;
    });
    next.unshift(entry);
    if (next.length > MAX_ENTRIES) next = next.slice(0, MAX_ENTRIES);
    writeRaw(next);
    syncTriggers();
    if (panelEl && panelEl.classList.contains('is-open')) renderList();
  }

  function removeByVariantId(variantId) {
    var id = String(variantId);
    writeRaw(
      listActive().filter(function (row) {
        return String(row.variantId) !== id;
      })
    );
    syncTriggers();
  }

  function syncCartCache(cart) {
    cartByKey = Object.create(null);
    if (!cart || !Array.isArray(cart.items)) return;
    cart.items.forEach(function (item) {
      if (item && item.key) cartByKey[item.key] = item;
    });
    if (cart.currency) {
      window.__erosCartRrCurrency = cart.currency;
    }
  }

  function refreshCartCache() {
    return fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
      })
      .then(function (cart) {
        syncCartCache(cart);
        return cart;
      });
  }

  function parseChangeBody(init) {
    if (!init || init.body == null) return null;
    if (typeof init.body === 'string') {
      try {
        return JSON.parse(init.body);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function isCartChangeUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/change') !== -1;
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = requestUrl(input);
    var body = isCartChangeUrl(url) ? parseChangeBody(init) : null;
    var pendingKey = null;
    var pendingZero = false;

    if (body && body.id != null) {
      var qty = parseInt(body.quantity, 10);
      if (qty === 0) {
        pendingKey = String(body.id);
        pendingZero = true;
      }
    }

    var ensure = Promise.resolve();
    if (pendingZero && pendingKey && !cartByKey[pendingKey]) {
      ensure = refreshCartCache().catch(function () {});
    }

    return ensure.then(function () {
      var snapshot = pendingZero && pendingKey ? cartByKey[pendingKey] : null;
      return nativeFetch(input, init).then(function (response) {
        if (pendingZero && snapshot && response && response.ok) {
          archiveFromCartItem(snapshot);
        }
        return response;
      });
    });
  };

  // `cents` here is Shopify Cart-AJAX minor units (item.final_price etc.).
  // window.Shopify.formatMoney is never actually defined in this theme
  // (confirmed live — the platform-injected `Shopify` global doesn't carry
  // it), so the old code fell through to `(cents/100).toFixed(2)`, which on a
  // zero-decimal currency like IQD both divided wrongly and forced decimals —
  // "15,000 د.ع" rendered as "150.00". The fix — format the store's own
  // moneyFormat setting string directly — now lives once in
  // eros-commerce-ui.js (window.ErosUI.formatMoneyCents), which loads
  // earlier in layout/theme.liquid <head> and is `defer`red the same as this
  // script, so it has always finished executing by the time this IIFE runs.
  function formatMoney(cents) {
    return window.ErosUI.formatMoneyCents(cents);
  }

  function escapeHtml(str) {
    // Escapes all 5 HTML-significant chars including the single quote (&#39;).
    // Current call sites place the result inside double-quoted attributes /
    // element text where a bare ' is harmless; escaping it too keeps this safe
    // against a future single-quoted-attribute edit (matches the canonical
    // version in eros-hybrid-search.js).
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function productHref(entry) {
    if (entry.url) {
      if (entry.url.charAt(0) === '/') return entry.url;
      return root().replace(/\/?$/, '/') + String(entry.url).replace(/^\//, '');
    }
    if (entry.handle) {
      return root() + 'products/' + encodeURIComponent(entry.handle);
    }
    return '';
  }

  function ensurePanel() {
    if (panelEl && document.body.contains(panelEl)) return panelEl;
    mergeI18nFromDom();

    panelEl = document.createElement('div');
    panelEl.id = PANEL_ID;
    panelEl.className = 'eros-cart-rr';
    panelEl.setAttribute('hidden', '');
    panelEl.innerHTML =
      '<div class="eros-cart-rr__scrim" data-eros-cart-rr-close tabindex="-1"></div>' +
      '<aside class="eros-cart-rr__panel" role="dialog" aria-modal="true" aria-labelledby="eros-cart-rr-title">' +
      '<div class="eros-cart-rr__header">' +
      '<h2 id="eros-cart-rr-title" class="eros-cart-rr__title"></h2>' +
      '<p class="eros-cart-rr__subtitle"></p>' +
      '<button type="button" class="eros-cart-rr__close" data-eros-cart-rr-close aria-label="Close">' +
      '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="eros-cart-rr__body" data-eros-cart-rr-list></div>' +
      '</aside>';

    panelEl.querySelector('.eros-cart-rr__title').textContent = i18n.title;
    panelEl.querySelector('.eros-cart-rr__subtitle').textContent = i18n.subtitle;
    document.body.appendChild(panelEl);

    panelEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-eros-cart-rr-close]')) {
        closePanel();
        return;
      }
      var restoreBtn = event.target.closest('[data-eros-cart-rr-restore]');
      if (restoreBtn) {
        event.preventDefault();
        restoreEntry(restoreBtn.getAttribute('data-eros-cart-rr-restore'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && panelEl && panelEl.classList.contains('is-open')) {
        closePanel();
      }
    });

    return panelEl;
  }

  function renderList() {
    var listHost = ensurePanel().querySelector('[data-eros-cart-rr-list]');
    if (!listHost) return;
    var entries = listActive();
    if (!entries.length) {
      listHost.innerHTML =
        '<p class="eros-cart-rr__empty">' + escapeHtml(i18n.empty) + '</p>';
      return;
    }

    listHost.innerHTML = entries
      .map(function (entry) {
        var title = entry.title || entry.variantId;
        var href = productHref(entry);
        var priceHtml = formatMoney(entry.price);
        var compareHtml =
          entry.compareAt != null && Number(entry.compareAt) > Number(entry.price)
            ? '<span class="eros-cart-rr__compare">' +
              escapeHtml(formatMoney(entry.compareAt)) +
              '</span>'
            : '';
        var variant =
          entry.variantTitle &&
          entry.variantTitle !== 'Default Title' &&
          entry.variantTitle !== 'Default'
            ? '<span class="eros-cart-rr__variant">' +
              escapeHtml(entry.variantTitle) +
              '</span>'
            : '';
        var img = entry.image
          ? '<img class="eros-cart-rr__thumb" src="' +
            escapeHtml(entry.image) +
            '" alt="" width="56" height="56" loading="lazy">'
          : '<span class="eros-cart-rr__thumb eros-cart-rr__thumb--empty" aria-hidden="true"></span>';
        var mediaInner = href
          ? '<a class="eros-cart-rr__media-link" href="' + escapeHtml(href) + '">' + img + variant + '</a>'
          : '<div class="eros-cart-rr__media-link">' + img + variant + '</div>';
        var titleInner = href
          ? '<a class="eros-cart-rr__name" href="' + escapeHtml(href) + '">' + escapeHtml(title) + '</a>'
          : '<span class="eros-cart-rr__name">' + escapeHtml(title) + '</span>';

        return (
          '<article class="eros-cart-rr__row" data-variant-id="' +
          escapeHtml(entry.variantId) +
          '">' +
          '<div class="eros-cart-rr__row-main">' +
          '<div class="eros-cart-rr__media">' +
          mediaInner +
          '</div>' +
          '<div class="eros-cart-rr__meta">' +
          titleInner +
          '<div class="eros-cart-rr__price">' +
          '<span class="eros-cart-rr__amount">' +
          escapeHtml(priceHtml) +
          '</span>' +
          compareHtml +
          '</div>' +
          '</div>' +
          '</div>' +
          '<button type="button" class="eros-cart-rr__restore button" data-eros-cart-rr-restore="' +
          escapeHtml(entry.variantId) +
          '">' +
          escapeHtml(i18n.addToCart) +
          '</button>' +
          '</article>'
        );
      })
      .join('');
  }

  function openPanel() {
    var el = ensurePanel();
    renderList();
    el.removeAttribute('hidden');
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });
    document.documentElement.classList.add('eros-cart-rr-open');
  }

  function closePanel() {
    if (!panelEl) return;
    panelEl.classList.remove('is-open');
    document.documentElement.classList.remove('eros-cart-rr-open');
    window.setTimeout(function () {
      if (panelEl && !panelEl.classList.contains('is-open')) {
        panelEl.setAttribute('hidden', '');
      }
    }, 280);
  }

  function syncTriggers() {
    var count = listActive().length;
    document.querySelectorAll('[data-eros-cart-rr-open]').forEach(function (btn) {
      btn.setAttribute('aria-label', i18n.openTooltip);
      btn.setAttribute('title', i18n.openTooltip);
      var badge = btn.querySelector('[data-eros-cart-rr-badge]');
      if (!badge) return;
      if (count > 0) {
        badge.hidden = false;
        badge.textContent = String(count);
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }

  function afterCartMutated(cart) {
    if (cart) syncCartCache(cart);
    else refreshCartCache().catch(function () {});
    syncTriggers();
  }

  function restoreEntry(variantId) {
    if (restoring || variantId == null) return;
    var id = String(variantId);
    var entry = listActive().find(function (row) {
      return String(row.variantId) === id;
    });
    if (!entry) return;

    var qty = parseInt(entry.quantity, 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;
    qty = Math.min(qty, QTY_CAP);

    restoring = true;
    var btn = panelEl && panelEl.querySelector('[data-eros-cart-rr-restore="' + id + '"]');
    if (btn) btn.disabled = true;

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    );

    // Same fix as eros-plp-quick-add.js / eros-pdp-cart-stepper.js: theme.js's
    // CartDrawer reads event.detail.cart.sections unconditionally and throws
    // if it's missing. This function used to work around that by also
    // dispatching cart:refresh right after cart:change — refreshCart_fn
    // fetches the drawer's section HTML independently, so the drawer did
    // still end up correct, but only after an uncaught exception plus a
    // second, redundant network round-trip. Requesting `sections` up front
    // (matching every other add/change flow in this theme) makes cart:change
    // succeed on its own, so that fallback refresh is no longer needed.
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(id) || id, quantity: qty, sections: sectionsToBundle.join(',') }),
    })
      .then(function (res) {
        return res.json().then(function (payload) {
          if (!res.ok) throw new Error(payload.description || 'cart/add failed');
          return payload;
        });
      })
      .then(function (addResponse) {
        removeByVariantId(id);
        return fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (res) {
          if (!res.ok) throw new Error('cart.js failed');
          return res.json().then(function (cart) {
            cart.sections = addResponse.sections;
            return cart;
          });
        });
      })
      .then(function (cart) {
        syncCartCache(cart);
        var pageType =
          (window.themeVariables &&
            window.themeVariables.settings &&
            window.themeVariables.settings.pageType) ||
          '';
        if (pageType === 'cart') {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'eros-cart-rr:restore', cart: cart },
          })
        );
        renderList();
        syncTriggers();
      })
      .catch(function () {
        if (btn) btn.disabled = false;
      })
      .finally(function () {
        restoring = false;
        document.documentElement.dispatchEvent(
          new CustomEvent('theme:loading:end', { bubbles: true })
        );
      });
  }

  function boot() {
    mergeI18nFromDom();
    listActive();
    syncTriggers();
    refreshCartCache().catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-eros-cart-rr-open]');
    if (!btn) return;
    event.preventDefault();
    openPanel();
  });

  document.addEventListener('cart:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    afterCartMutated(cart);
  });

  document.addEventListener('cart-drawer:refreshed', function () {
    mergeI18nFromDom();
    syncTriggers();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
